export default __webpack_public_path__ + "static/media/Kesht.18aa694d.jpg";